import React from 'react'

export default function CheckboxField({ children, id, ...props }) {
  return (
    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        id={id}
        className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
        {...props}
      />
      <label htmlFor={id} className="text-sm text-gray-500">
        {children}
      </label>
    </div>
  )
}